import React from "react";
import { Table, Popconfirm, Typography } from "antd";

const { Text } = Typography;

function StockCheckTable(props) {
  const {
    pagination,
    dataSource = [],
    loading = false,
    onView,
    onModify,
    onDelete,
    deleteAccess = true,
    modifyAccess = true,
    masterBinLocations = [],
  } = props;

  const columns = [
    {
      title: "Inward Date",
      dataIndex: "inwardDate",
      key: "inwardDate",
      width: 130,
      render: (text) => <span>{text || "N/A"}</span>,
    },
    {
      title: "Branch",
      dataIndex: "branchName",
      key: "branchName",
      width: 160,
      render: (text) => <span>{text || "Main Branch"}</span>,
    },
    {
      title: "Bin Location",
      dataIndex: "firstBinLocation",
      key: "firstBinLocation",
      width: 140,
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Bin Location Type",
      key: "binLocationType",
      width: 150,
      render: (_, record) => {
        const bin = record.firstBinLocation || "-";
        const isPermanent =
          bin !== "-" &&
          masterBinLocations.some((m) => {
            const mBranch = typeof m === "object" ? m.branch : null;
            const mLoc = (typeof m === "object" ? m.binLocation : m) || "";
            const matchesBranch = !mBranch || !record.branch || mBranch === record.branch;
            return (
              matchesBranch &&
              mLoc.trim().toUpperCase() === bin.trim().toUpperCase()
            );
          });
        const type = record.binLocationType || (bin === "-" ? "-" : isPermanent ? "PERMANENT" : "TEMP");
        return <span>{type}</span>;
      },
    },
    {
      title: "No of Parts",
      dataIndex: "noOfPartsCount",
      key: "noOfPartsCount",
      width: 110,
      render: (val) => <span>{val ?? 0}</span>,
    },
    {
      title: "Total PartsQty",
      dataIndex: "totalQtyCount",
      key: "totalQtyCount",
      width: 130,
      render: (val) => <span>{val ?? 0}</span>,
    },
    {
      title: "Inwarded By",
      dataIndex: "inwardedByName",
      key: "inwardedByName",
      width: 160,
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      width: 140,
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          {modifyAccess && (
            <span
              className="linkylink"
              onClick={(e) => {
                e.stopPropagation();
                onModify && onModify(record);
              }}
              style={{ marginRight: 12 }}
            >
              Modify
            </span>
          )}
          {deleteAccess && (
            <Popconfirm
              title="Do you want to delete this Stock Inward session?"
              okText="Yes"
              cancelText="No"
              onCancel={(e) => e.stopPropagation()}
              onConfirm={(e) => {
                e.stopPropagation();
                onDelete && onDelete(record.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(e) => e.stopPropagation()}
              >
                Delete
              </span>
            </Popconfirm>
          )}
          {!modifyAccess && !deleteAccess && (
            <Text strong disabled>
              No Actions Given
            </Text>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      pagination={pagination}
      tableLayout="fixed"
      loading={loading}
      onRow={(record) => ({
        onClick: () => onView && onView(record),
        style: { cursor: "pointer" },
      })}
    />
  );
}

export default StockCheckTable;

